import useDocumentTitle from '../../../hooks/useDocumentTitle';
import React from 'react';
import BulkPDFJobsFilters from '../components/BulkPDFJobsFilters';
import { Box, Stack } from '@mui/material';
import TopBar from '../../../components/TopBar';
import useBulkPDFJobsFilter from '../../../components/filters/BulkPDFJobsFilterHelper';
import { useCreateBulkPDFHandler } from '../dataHandlers/createBulkPDFHandler';
import { useGetBulkPDFHandler } from '../dataHandlers/getBulkPDFHandler';
import BulkPDFJobsTable from '../components/BulkPDFJobsTable';

const BulkPDFDownloadPage = () => {
  useDocumentTitle('Bulk PDF Download');

  const { currentQuery, handlePaginationChange } = useBulkPDFJobsFilter();
  const { bulkPDFs, totalJobs, loading } = useGetBulkPDFHandler({ searchQuery: currentQuery });
  const { onSubmit } = useCreateBulkPDFHandler();

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title="Bulk PDF Download" />
      <Box sx={{ mt: 3 }}>
        <BulkPDFJobsFilters onbulkpdfdownload={onSubmit} isLoading={loading} />
      </Box>
      <BulkPDFJobsTable
        handlePaginationChange={handlePaginationChange}
        bulkPDFs={bulkPDFs}
        totalJobs={totalJobs}
        loading={loading}
      />
    </Stack>
  );
};

export default BulkPDFDownloadPage;
